/* eslint-disable */

import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import client from '../../api/client';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import VoucherPicker from '../../components/card/VoucherPicker';
import placeholderImg from '../../assets/images/placeholder.webp';
import './CardMyCart.css';
import './MarketPlace.css';
import './ModalPayment.css';

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

const REGISTER_AUTH_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'multipart/form-data;',
  Authorization: 'Basic ' + btoa('Hvqhzd3f_zAXSsK7x2QfslGn0EvBoj'),
};

const EMPTY_ARRAY = [];

function MyPayment(props) {
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const shopId = props.permitdata?.shop_id;
  const source = searchParams.get('source');
  const shopitem = searchParams.get('shopitem');
  const item = searchParams.get('item');

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const [select_province, setSelect_province] = useState('');
  const [select_amphur, setSelect_amphur] = useState('');
  const [select_tambol, setSelect_tambol] = useState('');

  const [courierAPI_status, setCourierAPI_status] = useState(true);
  const [payment_method_arr, setPayment_method_arr] = useState(['cash', 'promtpay', 'creditcard']);

  const [bookbank_info, setBookbank_info] = useState({
    name: '',
    account_no: '',
    payment_id: '',
    payment_total: '',
    payment_expire: '',
  });

  const [cartdata_checksum, setCartdata_checksum] = useState('');
  const [mypayment_orderdata, setMypayment_orderdata] = useState([]);
  const [payment_summary, setPayment_summary] = useState({
    shop_subtotal: '',
    shop_shipping: '',
    shop_discount: '',
    shop_creditcharge: '',
    shop_servicecharge: '',
    shop_total: '',
    shop_checksum: '',
  });
  const [payment_summary_normal, setPayment_summary_normal] = useState({
    shop_subtotal: '',
    shop_shipping: '',
    shop_discount: '',
    shop_creditcharge: '',
    shop_servicecharge: '',
    shop_total: '',
    shop_checksum: '',
  });
  const [payment_summary_credit, setPayment_summary_credit] = useState({
    shop_subtotal: '',
    shop_shipping: '',
    shop_discount: '',
    shop_creditcharge: '',
    shop_servicecharge: '',
    shop_total: '',
    shop_checksum: '',
  });

  const SELLER_COURIER_OPTION = { display: 'จัดส่งโดยผู้ขาย', value: 'SELLER' };
  const DEFAULT_COURIER_OPTION = { display: 'Flash Express', value: 'FLE' };

  const [payment_permit, setPayment_permit] = useState(true);
  const [payment_method, setPayment_method] = useState(1);
  const [editshipping, setEditshipping] = useState(false);
  const [editcourier, setEditcourier] = useState(false);
  const [courier_code, setCourier_code] = useState(DEFAULT_COURIER_OPTION);
  const [sellerShippingEnabled, setSellerShippingEnabled] = useState(false);
  const [sellerShippingInitialized, setSellerShippingInitialized] = useState(false);
  const [shipping, setShipping] = useState({
    name: props.permitdata.shop_firstname + ' ' + props.permitdata.shop_lastname,
    telno: props.permitdata.shop_telno,
    address: props.permitdata.shop_address,
    district: props.permitdata.shop_subdistrict,
    state: props.permitdata.shop_district,
    province: props.permitdata.shop_province,
    postcode: props.permitdata.shop_postcode,
  });

  const [editcoupon, setEditcoupon] = useState(false);
  const [coupon_id, setCoupon_id] = useState('');
  const [availableCoupons, setAvailableCoupons] = useState([]);
  const [useCoins, setUseCoins] = useState(false);
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
    confirmcode: '',
  });

  const [modalbookbank, setModalbookbank] = useState(false);

  const [loadParams, setLoadParams] = useState(null);

  const { data: list_province_data } = useQuery({
    queryKey: ['address-province'],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', 'all');
      const response = await client.post('/api/account/register/address/getprovince', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'getprovince failed');
      }
      return response.data.data_province;
    },
    staleTime: Infinity,
  });

  useEffect(() => {
    if (props.permitdata?.token) {
      fetchAvailableCoupons();
    }
  }, [props.permitdata?.token, props.permitdata?.shop_id]);

  const fetchAvailableCoupons = async () => {
    try {
      const formData = new FormData();
      formData.append('buyer_shopid', props.permitdata?.shop_id || '');
      const response = await client.post('/api/order/coupon/getavailable', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${props.permitdata?.token}`,
        },
      });
      if (response.data.status === 'OK') {
        setAvailableCoupons(response.data.coupons || []);
      }
    } catch (e) {
      console.error('Failed to fetch available coupons', e);
    }
  };

  const { data: walletData } = useQuery({
    queryKey: ['wallet-balance', props.permitdata?.shop_id],
    queryFn: async () => {
      if (!props.permitdata?.shop_id) return { balance: 0 };
      const formData = new FormData();
      formData.append('buyer_shopid', props.permitdata.shop_id);
      const response = await client.post('/api/order/wallet/balance', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${props.permitdata?.token}`,
        },
      });
      if (response.data.status) {
        return response.data;
      }
      return { balance: 0 };
    },
    enabled: Boolean(props.permitdata?.token && props.permitdata?.shop_id),
  });
  const walletBalance = Number(walletData?.balance || 0);

  const list_province = list_province_data ?? EMPTY_ARRAY;

  const { data: list_amphur_data } = useQuery({
    queryKey: ['address-amphur', select_province],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', select_province);
      const response = await client.post('/api/account/register/address/getamphure', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'getamphure failed');
      }
      return response.data.data_amphure;
    },
    enabled: select_province !== '',
  });
  const list_amphur = list_amphur_data ?? EMPTY_ARRAY;

  const { data: list_tambol_data } = useQuery({
    queryKey: ['address-tambol', select_province, select_amphur],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('province', select_province);
      formData.append('amphur', select_amphur);
      const response = await client.post('/api/account/register/address/gettambol', formData, {
        headers: REGISTER_AUTH_HEADERS,
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'gettambol failed');
      }
      return response.data.data_tambol;
    },
    enabled: select_amphur !== '',
  });
  const list_tambol = list_tambol_data ?? EMPTY_ARRAY;

  const { data: categoryListData } = useQuery({
    queryKey: ['product-category-list'],
    queryFn: async () => {
      const response = await client.post('/api/product/category/getlist');
      if (response.data.status === 'OK') {
        return response.data.products || [];
      }
      return [];
    },
    staleTime: 5 * 60 * 1000,
  });
  const categoryList = categoryListData ?? EMPTY_ARRAY;

  const cartCategoryIds = useMemo(() => {
    const ids = new Set();
    (mypayment_orderdata || []).forEach((cart) => {
      (cart.cartitem || []).forEach((item) => {
        if (item.productcategory_id) {
          ids.add(String(item.productcategory_id).trim());
        }
      });
    });
    return Array.from(ids);
  }, [mypayment_orderdata]);

  const { cartSubtotal, cartCategorySubtotals } = useMemo(() => {
    let total = 0;
    const catTotals = {};
    (mypayment_orderdata || []).forEach((cart) => {
      (cart.cartitem || []).forEach((item) => {
        const cid = String(item.productcategory_id || '').trim();
        let itemTotal = 0;
        (item.cartitem_pricelist || []).forEach((pl) => {
          const price = Number(pl.pricepromotion || pl.price || 0);
          const amount = Number(pl.select || pl.unit || 0);
          const sub = Number(pl.subtotal) || price * amount;
          itemTotal += sub;
        });
        total += itemTotal;
        if (cid) {
          catTotals[cid] = (catTotals[cid] || 0) + itemTotal;
        }
      });
    });
    return { cartSubtotal: total, cartCategorySubtotals: catTotals };
  }, [mypayment_orderdata]);

  const paymentCartQuery = useQuery({
    queryKey: [
      'payment-cart',
      source,
      shopId,
      source === 'product' ? shopitem : null,
      source === 'product' ? item : null,
      payment_method_arr[payment_method - 1] ?? 'cash',
      loadParams?.coupon ?? '',
      loadParams?.carrier ?? '',
      useCoins,
      loadParams?.shipping?.name,
      loadParams?.shipping?.telno,
      loadParams?.shipping?.address,
      loadParams?.shipping?.district,
      loadParams?.shipping?.state,
      loadParams?.shipping?.province,
      loadParams?.shipping?.postcode,
    ],
    queryFn: async () => {
      await sleep(200);
      const shipinfo = loadParams.shipping;
      const formData = new FormData();
      formData.append('buyer_shopid', shopId);
      formData.append('coupon_id', loadParams.coupon);
      formData.append('deliver_req', 'enable');
      formData.append('shipping_recievename', shipinfo.name);
      formData.append('shipping_telno', shipinfo.telno);
      formData.append('shipping_address', shipinfo.address);
      formData.append('shipping_district', shipinfo.district);
      formData.append('shipping_state', shipinfo.state);
      formData.append('shipping_province', shipinfo.province);
      formData.append('shipping_postcode', shipinfo.postcode);
      formData.append('courier_code', loadParams.carrier);
      formData.append('sourcetype', 'order');
      formData.append('use_coins', useCoins ? 'true' : 'false');
      formData.append('coins_amount', String(walletBalance));

      let endpoint;
      const currentPm = payment_method_arr[payment_method - 1] ?? 'cash';
      formData.append('payment_method', currentPm);

      if (source === 'product') {
        formData.append('shopitem_id', shopitem);
        formData.append('item', item.replaceAll('--', '##'));
        endpoint = '/api/order/mycart/singlecartlist';
      } else {
        endpoint = '/api/order/mycart/cartlist';
      }

      const response = await client.post(endpoint, formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      if (response.data.status !== 'OK') {
        const err = new Error(response.data.message || 'payment cart load failed');
        err.isWarning = true;
        throw err;
      }
      return response.data;
    },
    enabled: Boolean(
      !!shopId &&
        !!loadParams?.shipping &&
        (source === 'cart' || (source === 'product' && !!shopitem && !!item)),
    ),
  });

  const bookingCreateMutation = useMutation({
    mutationFn: async (formData) => {
      await sleep(200);
      const response = await client.post('/api/order/booking/create', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      return response.data;
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        queryClient.invalidateQueries({ queryKey: ['cart', shopId] });
        if (data.payment_method === 'cash') {
          setEditcourier(false);
          setEditshipping(false);
          setEditcoupon(false);
          setPayment_permit(false);
          setBookbank_info(data.bookbank_info);
          open_bookbank();
        } else if (data.payment_method === 'promtpay') {
          setEditcourier(false);
          setEditshipping(false);
          setEditcoupon(false);
          setPayment_permit(false);
          if (data.qrcode_info && data.qrcode_info.PaymentUrl !== '') {
            window.location.href = data.qrcode_info.PaymentUrl;
          }
        } else if (data.payment_method === 'creditcard') {
          if (data.creditcard_info && data.creditcard_info.PaymentUrl !== '') {
            window.location.href = data.creditcard_info.PaymentUrl;
          }
        }
      } else {
        setModalbookbank(false);
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }

      if (data.readback !== undefined) {
        if (data.readback === true) {
          props.callback_maindatachange('myorder-array-add', data.myorder);
        }
      }
      if (data.cartcount !== undefined) {
        if (data.cartcount > -1) {
          props.callback_mycart('edit', data.cartcount);
        }
      }
    },
    onError: (err) => {
      setModalbookbank(false);
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const submitPayslipMutation = useMutation({
    mutationFn: async (formData) => {
      await sleep(200);
      const response = await client.post('/api/order/payment/submitpayslip', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      return response.data;
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status === 'OK') {
        setModalbookbank(false);
        setModal_popup({
          modaltype: 'modal-success',
          headers: 'สำเร็จ',
          message: data.message,
          enable: true,
        });
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
      }
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  useEffect(() => {
    if (select_province !== shipping.province) {
      setSelect_amphur('');
      setSelect_tambol('');
    }
  }, [select_province]);

  useEffect(() => {
    if (select_amphur !== shipping.state) {
      setSelect_tambol('');
    }
  }, [select_amphur]);

  useEffect(() => {
    if (props.permitdata != undefined) {
      const getVal = (v) => (v && v !== '-' ? v : '');
      const s_info = {
        name: [getVal(props.permitdata.shop_firstname), getVal(props.permitdata.shop_lastname)]
          .filter(Boolean)
          .join(' '),
        telno: getVal(props.permitdata.shop_telno),
        address: getVal(props.permitdata.shop_address),
        district: getVal(props.permitdata.shop_subdistrict),
        state: getVal(props.permitdata.shop_district),
        province: getVal(props.permitdata.shop_province),
        postcode: getVal(props.permitdata.shop_postcode),
      };
      setShipping(s_info);
      setLoadParams({
        coupon: '',
        carrier: DEFAULT_COURIER_OPTION.value,
        shipping: s_info,
      });
    }
  }, [props.permitdata]);

  useEffect(() => {
    if (paymentCartQuery.isFetching) {
      setmodal_load({ enable: true, message: 'ระบบกำลังโหลดข้อมูลสินค้า และคำนวณราคา' });
    } else {
      setmodal_load({ enable: false, message: '' });
    }
  }, [paymentCartQuery.isFetching]);

  useEffect(() => {
    if (!paymentCartQuery.error) return;
    const err = paymentCartQuery.error;
    setModal_popup({
      modaltype: err.isWarning ? 'modal-warning' : 'modal-error',
      headers: err.isWarning ? 'ขออภัย' : 'ผิดพลาด',
      message: err.message,
      enable: true,
    });
  }, [paymentCartQuery.error]);

  useEffect(() => {
    if (!paymentCartQuery.data || !loadParams) return;

    const response = paymentCartQuery.data;
    const carrier = loadParams.carrier;
    const coupon = loadParams.coupon;

    const enableSeller = response.cartdata.every((order) => order.has_fulfillment === true);
    if (enableSeller) {
      if (!sellerShippingInitialized) {
        setSellerShippingInitialized(true);
        setSellerShippingEnabled(true);
        if (carrier !== SELLER_COURIER_OPTION.value) {
          setCourier_code(SELLER_COURIER_OPTION);
          setLoadParams((prev) => ({ ...prev, carrier: SELLER_COURIER_OPTION.value }));
          return;
        }
      } else {
        setSellerShippingEnabled(true);
      }
    } else {
      if (sellerShippingInitialized) {
        setSellerShippingInitialized(false);
      }
      setSellerShippingEnabled(false);
      if (carrier === SELLER_COURIER_OPTION.value) {
        setCourier_code(DEFAULT_COURIER_OPTION);
        setLoadParams((prev) => ({ ...prev, carrier: DEFAULT_COURIER_OPTION.value }));
        return;
      }
    }

    setMypayment_orderdata(response.cartdata);
    setCartdata_checksum(response.cartdata_checksum);
    setPayment_summary_normal(response.summary_normal);
    setPayment_summary_credit(response.summary_credit);
    if (response.coupon_msg === 'OK') {
      setCoupon_id(coupon);
      setEditcoupon(false);
      var formelement = document.getElementById('form-coupon');
      if (formelement !== null) {
        formelement.classList.remove('was-validated');
      }
      var formfeedback = document.getElementById('coupon_feedback');
      if (formfeedback !== null) {
        formfeedback.innerText = '';
      }
    } else {
      setEditcoupon(true);
      var formelement = document.getElementById('form-coupon');
      if (formelement !== null) {
        formelement.classList.remove('was-validated');
      }
      var formfeedback = document.getElementById('coupon_feedback');
      if (formfeedback !== null) {
        formfeedback.innerText = response.coupon_msg;
      }
    }
    setCourierAPI_status(response.shipping_status);
  }, [paymentCartQuery.data, loadParams?.carrier]);

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function handleCheckoutClick() {
    const hasValidShipping = Boolean(
      shipping?.name &&
        shipping.name !== '-' &&
        shipping.name.trim() !== '' &&
        shipping?.telno &&
        shipping.telno !== '-' &&
        shipping.telno.trim() !== '' &&
        shipping?.address &&
        shipping.address !== '-' &&
        shipping.address.trim() !== '' &&
        shipping?.province &&
        shipping.province !== '-' &&
        shipping.province.trim() !== '',
    );

    if (!hasValidShipping) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'กรุณาระบุที่อยู่จัดส่ง',
        message: 'กรุณากรอกชื่อผู้รับ เบอร์โทรศัพท์ และที่อยู่ในการจัดส่งให้ครบถ้วนก่อนทำการสั่งซื้อ',
        enable: true,
      });
      setEditshipping(true);
      return;
    }

    if (payment_method === 0) {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'กรุณาเลือกวิธีการชำระเงิน',
        enable: true,
      });
      return;
    }

    setModal_popup({
      modaltype: 'modal-confirm',
      headers: 'ยืนยันคำสั่งซื้อ',
      message: 'กด "ยืนยัน" เพื่อสร้างคำสั่งซื้อ จากนั้นทำการแจ้งชำระเงิน',
      confirmcode: 'pay',
      confirmLabel: 'ยืนยัน',
      cancelLabel: 'ยกเลิก',
      enable: true,
    });
  }

  function showDialogCallback_Confirm(message) {
    if (message === 'pay') {
      api_submit_payment();
    } else if (message === 'cancel') {
    }
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  useEffect(() => {
    if (payment_method !== 3) {
      setPayment_summary(payment_summary_normal);
    } else {
      setPayment_summary(payment_summary_credit);
    }
  }, [payment_method, payment_summary_normal, payment_summary_credit]);

  function saveeditshipping() {
    var formelement = document.getElementById('form-address');
    if (formelement !== null) {
      formelement.classList.remove('was-validated');
      if (formelement.checkValidity() === false) {
        formelement.classList.add('was-validated');
      } else {
        formelement.classList.remove('was-validated');

        var s_info = {
          name: document.getElementById('shipping_recievename').value,
          telno: document.getElementById('shipping_telno').value,
          address: document.getElementById('shipping_address').value,
          district: document.getElementById('shipping_district').value,
          state: document.getElementById('shipping_state').value,
          province: document.getElementById('shipping_province').value,
          postcode: document.getElementById('shipping_postcode').value,
        };
        setLoadParams((prev) => ({
          ...prev,
          shipping: s_info,
        }));
        setShipping(s_info);
        setEditshipping(false);
      }
    }
  }

  useEffect(() => {
    if (editshipping) {
      setSelect_province(
        shipping.province && shipping.province !== '-' ? shipping.province : '',
      );
      setSelect_amphur(shipping.state && shipping.state !== '-' ? shipping.state : '');
      setSelect_tambol(shipping.district && shipping.district !== '-' ? shipping.district : '');
    } else {
      var formelement = document.getElementById('form-address');
      if (formelement !== null) {
        formelement.classList.remove('was-validated');
      }
    }
  }, [editshipping]);

  function submit_coupon() {
    const inputElem = document.getElementById('coupon_id');
    const newCode = inputElem ? inputElem.value.trim().toUpperCase() : '';
    const formfeedback = document.getElementById('coupon_feedback');

    if (!newCode) {
      if (formfeedback) formfeedback.innerText = 'กรุณากรอกโค้ดส่วนลด';
      return;
    }

    if (formfeedback) formfeedback.innerText = '';

    const currentCodes = (loadParams?.coupon || '')
      .split(',')
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean);

    if (!currentCodes.includes(newCode)) {
      const combined = [...currentCodes, newCode].join(',');
      setLoadParams((prev) => ({
        ...prev,
        coupon: combined,
      }));
    }

    if (inputElem) {
      inputElem.value = '';
    }
  }

  function remove_single_coupon(codeToRemove) {
    const currentCodes = (loadParams?.coupon || '')
      .split(',')
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean);

    const remaining = currentCodes
      .filter((c) => c !== (codeToRemove || '').trim().toUpperCase())
      .join(',');

    setLoadParams((prev) => ({
      ...prev,
      coupon: remaining,
    }));
  }

  function apply_coupon_direct(code) {
    const cleanCode = (code || '').trim().toUpperCase();
    const currentCodes = (loadParams?.coupon || '')
      .split(',')
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean);

    if (!currentCodes.includes(cleanCode)) {
      const combined = [...currentCodes, cleanCode].join(',');
      setLoadParams((prev) => ({
        ...prev,
        coupon: combined,
      }));
    }
  }

  function cancel_bookbank() {
    setModalbookbank(false);
    // Navigate to My Shop → Buyer → Payment (ระบบซื้อ) and refresh page
    navigate('/myshop/buyer/payment');
    setTimeout(() => {
      window.location.reload();
    }, 50);
  }

  function open_bookbank() {
    document.getElementById('payslip').value = [];
    setModalbookbank(true);
  }

  async function submit_carrier() {
    var tm = document.getElementById('courier_code').value;
    if (tm === 'SELLER') {
      setCourier_code(SELLER_COURIER_OPTION);
    } else if (tm === 'FLE') {
      setCourier_code(DEFAULT_COURIER_OPTION);
    } else if (tm === 'DHL') {
      setCourier_code({
        display: 'DHL',
        value: 'DHL',
      });
    } else if (tm === 'SPX') {
      setCourier_code({
        display: 'SPX Xpress (Shopee)',
        value: 'SPX',
      });
    }
    setLoadParams((prev) => ({
      ...prev,
      carrier: tm,
    }));
    setEditcourier(false);
  }

  useEffect(() => {
    if (editcourier) {
      document.getElementById('courier_code').value = courier_code.value;
    }
  }, [editcourier]);

  async function api_submit_payment() {
    try {
      if (!mypayment_orderdata || mypayment_orderdata.length === 0) {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: 'กรุณาเลือกสินค้าเพื่อทำการชำระเงิน',
          enable: true,
        });
        return;
      }

      var shipping_avai = true;
      mypayment_orderdata.forEach((order) => {
        if (order.shipping_info && order.shipping_info.available === false) {
          shipping_avai = false;
        }
      });

      if (shipping_avai === true) {
        if (props.permitdata && props.permitdata.shop_id !== mypayment_orderdata[0].seller_shopid) {
          if (payment_method > 0) {
            var formData = new FormData();
            formData.append('source', source);

            formData.append('buyer_shopid', props.permitdata.shop_id);
            formData.append('buyer_shopname', props.permitdata.shop_name);
            formData.append('buyer_shopprovince', props.permitdata.shop_province);

            formData.append('payment_method', payment_method_arr[payment_method - 1]);

            formData.append('shipping_recievename', shipping.name);
            formData.append('shipping_telno', shipping.telno);
            formData.append('shipping_address', shipping.address);
            formData.append('shipping_district', shipping.district);
            formData.append('shipping_state', shipping.state);
            formData.append('shipping_province', shipping.province);
            formData.append('shipping_postcode', shipping.postcode);

            formData.append('summary_subtotal', payment_summary.shop_subtotal);
            formData.append('summary_shipping', payment_summary.shop_shipping);
            formData.append('summary_shipping_markup', payment_summary.shop_shipping_markup);
            formData.append('summary_discount', payment_summary.shop_discount);
            formData.append('summary_coins_discount', payment_summary.coins_discount || '0.00');
            formData.append('use_coins', useCoins ? 'true' : 'false');
            formData.append('summary_servicecharge', payment_summary.shop_servicecharge);
            formData.append('summary_creditcharge', payment_summary.shop_creditcharge);
            formData.append('summary_total', payment_summary.shop_total);
            formData.append('summary_net', payment_summary.shop_net);
            formData.append('summary_checksum', payment_summary.shop_checksum);
            formData.append('order_data_checksum', cartdata_checksum);

            formData.append('coupon_id', loadParams?.coupon || coupon_id || '');
            formData.append('courier_code', courier_code.value);

            formData.append('order_data', JSON.stringify(mypayment_orderdata));

            setmodal_load({ enable: true, message: 'ระบบกำลังสร้างคำสั่งซื้อของท่าน' });
            bookingCreateMutation.mutate(formData);
          } else {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: 'กรุณาเลือกวิธีการการชำระเงิน',
              enable: true,
            });
          }
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: 'ระบบไม่อนุญาตให้ซื้อสินค้าภายในร้านตัวเอง',
            enable: true,
          });
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message:
            'ตรวจพบปัญหาในการคำนวณราคา กรุณาลองใหม่อีกครั้ง โดยการโหลดหน้าใหม่ หรือแก้ไขข้อมูล',
          enable: true,
        });
      }
    } catch (error) {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: error.message || 'เกิดข้อผิดพลาดในการประมวลผล',
        enable: true,
      });
    }
  }

  async function api_upload_payslip() {
    var formelement = document.getElementById('form-payslip');
    var fileInput = document.getElementById('payslip');
    if (formelement.checkValidity() === false || !fileInput || !fileInput.files || fileInput.files.length === 0) {
      formelement.classList.add('was-validated');
    } else {
      formelement.classList.remove('was-validated');
      const formData = new FormData(formelement);
      formData.set('payslip', fileInput.files[0]);
      formData.append('payment_id', bookbank_info.payment_id);
      setmodal_load({ enable: true, message: 'กำลังอัพโหลดหลักฐานการชำระเงิน' });
      submitPayslipMutation.mutate(formData);
    }
  }

  return (
    <main id='content' role='main' className='bg-gray-13'>
      <div className='container py-4'>
        {/* Breadcrumb */}
        <nav aria-label='breadcrumb' className='d-none d-md-block mb-3'>
          <ol className='breadcrumb mb-0 py-0 bg-transparent'>
            <li className='breadcrumb-item font-th'>
              <Link to='/marketplace?category=รวมสินค้า' className='text-primary'>
                หน้าแรก
              </Link>
            </li>
            <li className='breadcrumb-item font-th active'>ชำระเงิน</li>
          </ol>
        </nav>

        {payment_permit === true || (payment_permit === false && payment_method > 0) ? (
          <div className='row'>
            <div className='col-lg-8 col-xl-9'>
              {/* Shipping Address Card */}
              <div className='card-mycart mb-4'>
                <div className='card-mycart-header'>
                  <div className='card-mycart-title'>
                    <i className='fas fa-map-marked-alt'></i> ที่อยู่ในการจัดส่ง
                  </div>
                  {payment_permit === true && (
                    <button
                      className='btn btn-link p-0 font-th'
                      onClick={() => setEditshipping(!editshipping)}
                    >
                      {editshipping ? 'ปิด' : 'แก้ไขที่อยู่'}
                    </button>
                  )}
                </div>
                <div className='card-mycart-body'>
                  {editshipping ? (
                    <div className='shipping-edit-form'>
                      <form id='form-address' className='needs-validation' noValidate>
                        <div className='row'>
                          <div className='col-md-6 mb-3'>
                            <label className='font-th'>ชื่อ-นามสกุล ผู้รับ</label>
                            <input
                              type='text'
                              id='shipping_recievename'
                              className='form-control'
                              required
                              defaultValue={shipping.name !== '-' ? shipping.name : ''}
                            />
                          </div>
                          <div className='col-md-6 mb-3'>
                            <label className='font-th'>เบอร์โทรศัพท์</label>
                            <input
                              type='text'
                              id='shipping_telno'
                              className='form-control'
                              required
                              defaultValue={shipping.telno !== '-' ? shipping.telno : ''}
                            />
                          </div>
                        </div>
                        <div className='mb-3'>
                          <label className='font-th'>ที่อยู่ (บ้านเลขที่, ซอย, ถนน)</label>
                          <textarea
                            id='shipping_address'
                            className='form-control'
                            rows='2'
                            required
                            defaultValue={shipping.address !== '-' ? shipping.address : ''}
                          ></textarea>
                        </div>
                        <div className='row'>
                          <div className='col-md-4 mb-3'>
                            <label className='font-th'>จังหวัด</label>
                            <select
                              id='shipping_province'
                              className='form-control'
                              required
                              value={select_province}
                              onChange={(e) => setSelect_province(e.target.value)}
                            >
                              <option value=''>เลือกจังหวัด</option>
                              {(list_province || []).map((p) => {
                                const label =
                                  typeof p === 'object' ? p.province || p.name_th || '' : p;
                                return (
                                  <option key={label} value={label}>
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className='col-md-4 mb-3'>
                            <label className='font-th'>อำเภอ/เขต</label>
                            <select
                              id='shipping_state'
                              className='form-control'
                              required
                              value={select_amphur}
                              onChange={(e) => setSelect_amphur(e.target.value)}
                            >
                              <option value=''>เลือกอำเภอ</option>
                              {(list_amphur || []).map((a) => {
                                const label =
                                  typeof a === 'object' ? a.amphur || a.name_th || '' : a;
                                return (
                                  <option key={label} value={label}>
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className='col-md-4 mb-3'>
                            <label className='font-th'>ตำบล/แขวง</label>
                            <select
                              id='shipping_district'
                              className='form-control'
                              required
                              value={select_tambol}
                              onChange={(e) => setSelect_tambol(e.target.value)}
                            >
                              <option value=''>เลือกตำบล</option>
                              {(list_tambol || []).map((t) => {
                                const label =
                                  typeof t === 'object' ? t.tambol || t.name_th || '' : t;
                                return (
                                  <option key={label} value={label}>
                                    {label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-4 mb-3'>
                            <label className='font-th'>รหัสไปรษณีย์</label>
                            <input
                              type='text'
                              id='shipping_postcode'
                              className='form-control'
                              required
                              defaultValue={shipping.postcode !== '-' ? shipping.postcode : ''}
                            />
                          </div>
                        </div>
                        <div className='d-flex gap-2 mt-2'>
                          <button
                            type='button'
                            className='btn btn-primary px-4'
                            onClick={saveeditshipping}
                          >
                            บันทึก
                          </button>
                          <button
                            type='button'
                            className='btn btn-light px-4'
                            onClick={() => setEditshipping(false)}
                          >
                            ยกเลิก
                          </button>
                        </div>
                      </form>
                    </div>
                  ) : !shipping?.address ||
                    shipping.address === '-' ||
                    !shipping?.province ||
                    shipping.province === '-' ? (
                    <div
                      className='alert alert-warning font-th mb-0 d-flex justify-content-between align-items-center'
                      style={{ borderRadius: '10px' }}
                    >
                      <div>
                        <i className='fas fa-exclamation-triangle mr-2 text-warning'></i>
                        <strong>ยังไม่มีข้อมูลที่อยู่จัดส่ง</strong> กรุณาระบุที่อยู่ก่อนสั่งซื้อ
                      </div>
                      <button
                        type='button'
                        className='btn btn-warning btn-sm font-weight-bold font-th'
                        onClick={() => setEditshipping(true)}
                      >
                        <i className='fas fa-plus mr-1'></i> ระบุที่อยู่
                      </button>
                    </div>
                  ) : (
                    <div className='address-display font-th'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='bg-primary text-white rounded-pill px-3 py-1 small font-weight-bold mr-2'>
                          <i className='fas fa-user mr-1'></i> ผู้รับ
                        </div>
                        <div className='font-weight-bold'>
                          {shipping.name} | {shipping.telno}
                        </div>
                      </div>
                      <div className='text-secondary pl-1'>
                        <i className='fas fa-location-arrow mr-2 text-muted'></i>
                        {shipping.address} ต.{shipping.district} อ.{shipping.state} จ.
                        {shipping.province} {shipping.postcode}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Courier Selection Card */}
              <div className='card-mycart mb-4'>
                <div className='card-mycart-header'>
                  <div className='card-mycart-title'>
                    <i className='fas fa-truck'></i> ตัวเลือกการจัดส่ง
                  </div>
                  {payment_permit === true && (
                    <button
                      className='btn btn-link p-0 font-th'
                      onClick={() => setEditcourier(!editcourier)}
                    >
                      {editcourier ? 'ปิด' : 'เปลี่ยนบริษัทขนส่ง'}
                    </button>
                  )}
                </div>
                <div className='card-mycart-body'>
                  {editcourier ? (
                    <div className='courier-edit-form'>
                      <div className='form-group mb-3'>
                        <select
                          id='courier_code'
                          className='form-control'
                          defaultValue={courier_code.value}
                        >
                          {sellerShippingEnabled ? (
                            <option value='SELLER'>จัดส่งโดยผู้ขาย</option>
                          ) : (
                            <>
                              <option value='FLE'>Flash Express</option>
                              <option value='DHL'>DHL</option>
                            </>
                          )}
                        </select>
                      </div>
                      <div className='d-flex gap-2'>
                        <button className='btn btn-primary px-4' onClick={submit_carrier}>
                          ยืนยัน
                        </button>
                        <button
                          className='btn btn-light px-4'
                          onClick={() => setEditcourier(false)}
                        >
                          ยกเลิก
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className='courier-display d-flex align-items-center justify-content-between font-th'>
                      <div>
                        <div className='font-weight-bold'>{courier_code.display}</div>
                        <div className='text-secondary small'>
                          ระยะเวลาจัดส่งโดยประมาณ:{' '}
                          {mypayment_orderdata[0]?.shipping_info.estimate_time || '-'}
                        </div>
                      </div>
                      <div className='text-primary font-weight-bold h5 mb-0'>
                        ฿{Number(payment_summary.shop_shipping_markup).toLocaleString()}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Order Items */}
              {mypayment_orderdata.map((order) => (
                <div className='card-mycart mb-4' key={order.seller_shopid}>
                  <div className='card-mycart-header'>
                    <div className='d-flex flex-column'>
                      <div className='card-mycart-title'>
                        <i className='fas fa-store-alt'></i> {order.seller_shopname}
                      </div>
                      <span className='card-mycart-subtitle'>
                        จังหวัด {order.seller_shopprovince}
                      </span>
                    </div>
                    <div className='text-muted small font-th'>{order.cartitem.length} รายการ</div>
                  </div>
                  <div className='card-mycart-body'>
                    {order.cartitem.map((item) => (
                      <div className='mycart-item-row no-check' key={item.productitem_id}>
                        <div className='mycart-box-image'>
                          <img
                            src={
                              item.productitem_id && item.img1_key
                                ? `${process.env.REACT_APP_IMAGE_URL}${item.productitem_id}/${item.productitem_id}-1-${item.img1_key}.jpg`
                                : placeholderImg
                            }
                            alt={item.productitem_name}
                          />
                        </div>
                        <div className='mycart-item-info'>
                          <div className='mycart-box-productname'>{item.productitem_name}</div>
                          <div className='mycart-box-productinter'>{item.productitem_inter}</div>
                          <div className='payment-pricelist-container mt-2'>
                            {item.cartitem_pricelist?.map((price) => (
                              <div
                                className='pricelist-item border-0 p-0 mb-1'
                                key={price.pricelist_id}
                              >
                                <div className='d-flex justify-content-between align-items-center font-th'>
                                  <div className='small text-secondary'>
                                    {price.unit} ชิ้น | Exp.{' '}
                                    {dayjs(new Date(price.expire)).format('DD MMM BBBB')} x{' '}
                                    {price.select}
                                  </div>
                                  <div className='font-weight-bold'>
                                    ฿{price.subtotal.toLocaleString()}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* Coupon Card */}
              <div className='card-mycart mb-4'>
                <div className='card-mycart-header'>
                  <div className='card-mycart-title'>
                    <i className='fas fa-ticket-alt'></i> โค้ดส่วนลด
                  </div>
                  {payment_permit && (
                    <button
                      className='btn btn-link p-0 font-th'
                      onClick={() => setEditcoupon(!editcoupon)}
                    >
                      {editcoupon ? 'ปิด' : loadParams?.coupon ? '+ เพิ่มโค้ดอีก' : 'ใช้โค้ดส่วนลด'}
                    </button>
                  )}
                </div>
                <div className='card-mycart-body'>
                  {editcoupon && (
                    <div className='coupon-edit-form mb-3'>
                      <form id='form-coupon' className='d-flex gap-2' onSubmit={(e) => { e.preventDefault(); submit_coupon(); }}>
                        <input
                          type='text'
                          id='coupon_id'
                          className='form-control font-th'
                          placeholder='กรอกโค้ดส่วนลด (เช่น MEYA100, FREESHIP)'
                          style={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}
                        />
                        <button
                          type='button'
                          className='btn btn-primary px-4 font-th'
                          onClick={submit_coupon}
                        >
                          + เพิ่มโค้ด
                        </button>
                      </form>
                      <div className='invalid-feedback d-block mt-1 text-danger font-th' id='coupon_feedback'>
                        {paymentCartQuery.data?.coupon_msg && paymentCartQuery.data.coupon_msg !== 'OK'
                          ? paymentCartQuery.data.coupon_msg
                          : ''}
                      </div>
                    </div>
                  )}

                  {/* Shopee-style Voucher Tickets & Available Public Coupons */}
                  <VoucherPicker
                    appliedCoupons={
                      paymentCartQuery.data?.applied_coupons && paymentCartQuery.data.applied_coupons.length > 0
                        ? paymentCartQuery.data.applied_coupons
                        : loadParams?.coupon
                        ? loadParams.coupon.split(',').map((c) => ({ coupon_id: c.trim() }))
                        : []
                    }
                    availableCoupons={availableCoupons}
                    showAvailable={editcoupon}
                    categoryList={categoryList}
                    cartCategoryIds={cartCategoryIds}
                    cartSubtotal={cartSubtotal}
                    cartCategorySubtotals={cartCategorySubtotals}
                    currentPaymentMethod={payment_method_arr[payment_method - 1] ?? 'cash'}
                    onApplyCoupon={apply_coupon_direct}
                    onRemoveCoupon={remove_single_coupon}
                  />

                  {!editcoupon && !loadParams?.coupon && (
                    <div className='coupon-display font-th text-muted mt-2'>
                      ไม่มีการใช้โค้ดส่วนลด
                    </div>
                  )}
                </div>
              </div>

              {/* Meya Coins Wallet Card (Shopee Coins Style) */}
              {walletBalance > 0 && (
                <div className='card-mycart mb-4'>
                  <div className='card-mycart-body p-3 font-th meya-coins-card-body'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <div className='meya-coins-icon-circle mr-3'>
                          <i className='fas fa-coins'></i>
                        </div>
                        <div>
                          <div
                            className='meya-coins-label font-weight-bold'
                            style={{ fontSize: '14px', color: '#1e293b' }}
                          >
                            ใช้ Meya Coins
                          </div>
                          <div className='text-muted' style={{ fontSize: '12px' }}>
                            เหรียญสะสมคงเหลือ:{' '}
                            <strong style={{ color: '#d97706' }}>
                              ฿
                              {Number(walletBalance).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                              })}
                            </strong>
                            {useCoins && Number(payment_summary?.coins_discount || 0) > 0 && (
                              <span className='text-success font-weight-bold ml-2'>
                                (ลดเพิ่ม ฿
                                {Number(payment_summary.coins_discount).toLocaleString(
                                  undefined,
                                  {
                                    minimumFractionDigits: 2,
                                  },
                                )}
                                )
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className='custom-control custom-switch custom-switch-md'>
                        <input
                          type='checkbox'
                          className='custom-control-input'
                          id='useCoinsSwitch'
                          checked={useCoins}
                          onChange={(e) => setUseCoins(e.target.checked)}
                        />
                        <label
                          className='custom-control-label'
                          htmlFor='useCoinsSwitch'
                          style={{ cursor: 'pointer' }}
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Summary Sidebar */}
            <div className='col-lg-4 col-xl-3'>
              {/* Payment Method Card */}
              <div className='card-mycart mb-4'>
                <div className='card-mycart-header'>
                  <div className='card-mycart-title'>
                    <i className='fas fa-credit-card'></i> เลือกช่องทางการชำระเงิน
                  </div>
                </div>
                <div className='card-mycart-body p-4'>
                  <div className='payment-methods-list'>
                    {[
                      {
                        id: 1,
                        title: 'โอนเงิน',
                        desc: 'ชำระแบบโอนเงินเข้าบัญชี',
                        icon: 'fa-university',
                      },
                      {
                        id: 2,
                        title: 'QR PromptPay',
                        desc: 'สแกน QR Code (ขั้นต่ำ 20 บาท)',
                        icon: 'fa-qrcode',
                      },
                      {
                        id: 3,
                        title: 'บัตรเครดิต / เดบิต',
                        desc: 'ชำระผ่านบัตรทันที',
                        icon: 'fa-credit-card',
                      },
                    ].map(
                      (m) =>
                        (payment_permit || payment_method === m.id) && (
                          <div
                            key={m.id}
                            className={`payment-method-box font-th ${payment_method === m.id ? 'active' : ''}`}
                            onClick={() => setPayment_method(m.id)}
                          >
                            <div className='payment-method-selected'>
                              <i className='fas fa-check'></i>
                            </div>
                            <div className='d-flex align-items-center'>
                              <i
                                className={`fas ${m.icon} mr-3 text-primary`}
                                style={{ fontSize: '20px', width: '24px' }}
                              ></i>
                              <div>
                                <h5 className='mb-0'>{m.title}</h5>
                                <p className='small text-muted mb-0'>{m.desc}</p>
                              </div>
                            </div>
                          </div>
                        ),
                    )}
                  </div>
                </div>
              </div>

              {/* Seller Note Card */}
              <div className='card-mycart mb-4'>
                <div className='card-mycart-header'>
                  <div className='card-mycart-title'>
                    <i className='fas fa-comment-dots'></i> หมายเหตุผู้ขาย
                  </div>
                </div>
                <div className='card-mycart-body p-4'>
                  <div className='seller-payment-note font-th m-0'>
                    <div className='note-body'>
                      ขณะนี้ยังไม่มีการหักค่าธรรมเนียม ผู้ขายจะได้รับเงินเต็มจำนวนตามมูลค่าสินค้า
                    </div>
                  </div>
                </div>
              </div>

              <div className='mycart-summary'>
                <div className='summary-title font-th mb-3'>สรุปยอดชำระ</div>
                <div className='summary-details font-th'>
                  <div className='summary-row'>
                    <span>มูลค่าสินค้า</span>
                    <strong>
                      ฿
                      {Number(payment_summary.shop_subtotal).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </strong>
                  </div>
                  <div className='summary-row'>
                    <span>ค่าขนส่ง</span>
                    <strong>
                      ฿
                      {Number(payment_summary?.shop_shipping_markup || 0).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits: 2,
                        },
                      )}
                    </strong>
                  </div>
                  {Number(payment_summary?.shop_discount || 0) > 0 && (
                    <div className='summary-row text-danger'>
                      <span>ส่วนลด</span>
                      <strong>
                        -฿
                        {Number(payment_summary?.shop_discount || 0).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </strong>
                    </div>
                  )}
                  {Number(payment_summary?.coins_discount || 0) > 0 && (
                    <div className='summary-row' style={{ color: '#ea580c' }}>
                      <span>
                        <i className='fas fa-coins mr-1 text-warning'></i> ส่วนลด Meya Coins
                      </span>
                      <strong className='text-success'>
                        -฿
                        {Number(payment_summary?.coins_discount || 0).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                          },
                        )}
                      </strong>
                    </div>
                  )}
                  {paymentCartQuery.data?.applied_coupons?.some((c) => c.coupon_type === 'cashback') && (
                    <div
                      className='summary-row py-2 my-1'
                      style={{
                        backgroundColor: '#fffbeb',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: '1px solid #fef3c7',
                        color: '#92400e',
                        fontSize: '13px',
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>
                        <i className='fas fa-coins mr-1 text-warning'></i> จะได้รับ Meya Coins
                      </span>
                      <strong style={{ color: '#d97706', fontSize: '13.5px', fontWeight: 700 }}>
                        {paymentCartQuery.data.applied_coupons
                          .filter((c) => c.coupon_type === 'cashback')
                          .map((c) => {
                            let coins =
                              (Number(payment_summary.shop_subtotal || 0) *
                                Number(c.cashback_percent || 0)) /
                              100;
                            if (c.max_discount > 0 && coins > c.max_discount) {
                              coins = c.max_discount;
                            }
                            return `+${coins.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                            })} Coins (${c.cashback_percent}%)`;
                          })
                          .join(', ')}
                      </strong>
                    </div>
                  )}
                  {payment_method === 3 && (
                    <>
                      <div className='summary-row pt-2 border-top'>
                        <span>ยอดรวม</span>
                        <strong>
                          ฿
                          {Number(payment_summary?.shop_total || 0).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })}
                        </strong>
                      </div>
                      <div className='summary-row text-muted small'>
                        <span>ค่าธรรมเนียมบัตร</span>
                        <strong>
                          ฿
                          {Number(payment_summary?.shop_creditcharge || 0).toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 2,
                            },
                          )}
                        </strong>
                      </div>
                    </>
                  )}
                  <div className='summary-row summary-total mt-2 pt-2 border-top'>
                    <span>ยอดสุทธิ</span>
                    <strong className='text-primary'>
                      ฿
                      {Number(payment_summary?.shop_net || 0).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                      })}
                    </strong>
                  </div>
                </div>

                <div className='checkout-actions d-grid gap-2 mt-4'>
                  {payment_permit ? (
                    <button
                      className='checkout-btn font-th'
                      disabled={payment_method === 0}
                      onClick={handleCheckoutClick}
                    >
                      ยืนยันคำสั่งซื้อ
                    </button>
                  ) : null}
                  <button className='back-btn font-th' onClick={() => navigate(-1)}>
                    <i className='fas fa-arrow-left mr-2'></i> ย้อนกลับ
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Bookbank Modal Implementation */}
      <div className='payment-bookbank' style={{ display: modalbookbank ? 'block' : 'none' }}>
        <div className='payment-bookbank-wrapper'>
          <h5 className='modal-title font-th mb-2'>บัญชีธนาคารสำหรับชำระเงิน</h5>
          <div className='text-secondary small font-th mb-3'>
            เลขที่อ้างอิง: <strong>{bookbank_info.payment_id}</strong>
          </div>

          <div className='alert alert-success font-th py-2 mb-4'>
            <i className='fas fa-check-circle mr-2'></i> สร้างคำสั่งซื้อสำเร็จ
            กรุณาชำระเงินและแนบสลิป
          </div>

          <div className='bank-account-card p-3 border rounded-lg d-flex align-items-center mb-4'>
            <img
              src={`${process.env.PUBLIC_URL}/images/KBank-logo.jpg`}
              alt='KBank'
              style={{ width: '60px', borderRadius: '12px' }}
            />
            <div className='ml-3 font-th'>
              <div className='text-success font-weight-bold'>ธนาคารกสิกรไทย</div>
              <div>ชื่อบัญชี: {bookbank_info.name}</div>
              <div className='h5 mb-0 font-weight-bold'>{bookbank_info.account_no}</div>
            </div>
          </div>

          <div className='payment-amount-box text-center p-3 bg-light rounded-lg mb-4 font-th'>
            <div className='text-muted small'>ยอดที่ต้องชำระ</div>
            <div className='h3 text-danger font-weight-bold mb-0'>
              ฿{bookbank_info.payment_total}
            </div>
            <div className='text-danger small mt-1'>
              *กรุณาชำระก่อน{' '}
              {dayjs(new Date(bookbank_info.payment_expire)).format('DD MMM BBBB HH:mm')}
            </div>
          </div>

          <form id='form-payslip' className='font-th'>
            <label className='font-weight-bold mb-2'>แนบสลิปโอนเงิน</label>
            <input
              className='form-control mb-2'
              type='file'
              id='payslip'
              name='payslip'
              accept='image/*'
              required
            />
            <p className='text-muted small'>
              ท่านสามารถแนบหลักฐานภายหลังได้ที่เมนู "ร้านค้าของฉัน"
            </p>
          </form>

          <div className='d-flex gap-2 mt-4'>
            <button
              className='btn btn-success flex-grow-1 py-3 font-th'
              onClick={api_upload_payslip}
            >
              ยืนยันแนบสลิป
            </button>
            <button className='btn btn-light px-4 py-3 font-th' onClick={cancel_bookbank}>
              ปิด
            </button>
          </div>
        </div>
      </div>

      <ModalLoad option={modal_load}></ModalLoad>
      <ModalPopupMessage
        callback_general={showDialogCallback_General}
        callback_confirm={showDialogCallback_Confirm}
        options={modal_popup}
      />
      {modalbookbank && <div className='meya-backdrop' onClick={cancel_bookbank}></div>}
    </main>
  );
}

export default MyPayment;
